let config = {
  inputLabel: 'offerName',
  key: 'offername',
  inputType: 'textfield',
};

export default config;
